export const messages = {
  en: {
    centralizedPurchase: {
      queryCondition: 'Query Conditions',
      selectServiceType: 'Select Service Type',
      inputServiceName: 'Input Service Name',
      selectStatus: 'Select Status',
      search: 'Search',
      appService: 'Application Services',
      restartAll: 'Restart All',
      addService: 'Add Service',
      quickDeploy: 'Quick Deploy',
      import: 'Import',
      export: 'Export',
      serviceType: 'Service Type',
      appName: 'Application Name',
      replicas: 'Replicas',
      image: 'Image',
      createTime: 'Create Time',
      status: 'Status',
      operations: 'Operations',
      console: 'Console',
      upgradeDowngrade: 'Upgrade/Downgrade',
      start: 'Start',
      stop: 'Stop',
      copy: 'Copy',
      delete: 'Delete',
      logs: 'Logs',
      startSuccess: 'Service started successfully',
      stopSuccess: 'Service stopped successfully',
      restartRequestSent: 'Restart request has been sent',
      groupName: 'Group Name'
    }
  },
  zh: {
    centralizedPurchase: {
      queryCondition: '查询条件',
      selectServiceType: '请选择服务类型',
      inputServiceName: '请输入服务名称',
      selectStatus: '请选择状态',
      search: '查询',
      appService: '应用服务',
      restartAll: '一键重启',
      addService: '添加服务',
      quickDeploy: '快速部署',
      import: '导入',
      export: '导出',
      serviceType: '服务类型',
      appName: '应用名称',
      replicas: '副本数',
      image: '镜像',
      createTime: '创建时间',
      status: '状态',
      operations: '操作',
      console: '控制台',
      upgradeDowngrade: '升降级',
      start: '启动',
      stop: '停止',
      copy: '拷贝',
      delete: '删除',
      logs: '日志',
      startSuccess: '服务启动成功',
      stopSuccess: '服务停止成功',
      restartRequestSent: '重启请求已发送',
      groupName: '分组名称'
    }
  }
}